import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { Observable } from 'rxjs';
import { getQueryStringFromObject, ListServerPaginationStateModel } from '../../../../../common';
import { ShipmentTransportOrderEndpoint } from '../../constants';
import {
  ShipmentTransportOrderMaterialListSearchCriteria,
  ShipmentTransportOrderMaterialModel,
} from '../../models/shipment-transport-order-materials.model';

@Injectable({
  providedIn: 'root',
})
export class ShipmentTransportOrderMaterialsService {
  constructor(private http: WrapperHttpService) {}

  getShipmentTransportOrderMaterials(
    searchCriteria: ShipmentTransportOrderMaterialListSearchCriteria,
  ): Observable<ListServerPaginationStateModel<ShipmentTransportOrderMaterialModel>> {
    return this.http
      .withLoading()
      .get<ListServerPaginationStateModel<ShipmentTransportOrderMaterialModel>>(
        `${API_URL}${ShipmentTransportOrderEndpoint.Base}${ShipmentTransportOrderEndpoint.Tos}${
          ShipmentTransportOrderEndpoint.Materials
        }?${getQueryStringFromObject(searchCriteria.transportOrderIdView)}&page=${searchCriteria.page}&size=${
          searchCriteria.size
        }`,
        searchCriteria.transportOrderIdView,
      );
  }
}
